import './card_obfuscated_email_component.scss'
import { Controller } from 'stimulus'

export default class extends Controller {
  static values = {
    username: String,
    domain: String
  }

  openEmailProgram = (): void => {
    window.open(`mailto:${this.username}@${this.domain}`, '_self')
  }

  get username (): string {
    return String(this.usernameValue)
  }

  get domain (): string {
    return String(this.domainValue)
  }
}
